/** Landing screen: drag-drop or pick a `.fit`. Rejections surface via the store's error signal. */
import { signal } from '@preact/signals'
import { useRef } from 'preact/hooks'
import { store } from '../state/store'

const dragOver = signal(false)

function loadFirst(files: FileList | null): void {
  const file = files?.[0]
  if (!file) return
  void file.arrayBuffer().then((buf) => store.loadFile(new Uint8Array(buf), file.name))
}

export function DropScreen() {
  const input = useRef<HTMLInputElement>(null)
  return (
    <div class="drop">
      <div
        class={`dropzone${dragOver.value ? ' over' : ''}`}
        onDragOver={(e) => {
          e.preventDefault()
          dragOver.value = true
        }}
        onDragLeave={() => (dragOver.value = false)}
        onDrop={(e) => {
          e.preventDefault()
          dragOver.value = false
          loadFirst(e.dataTransfer?.files ?? null)
        }}
      >
        <h1>Swim Editor</h1>
        <p>
          Drop a <code>.fit</code> file here, or choose one.<br/>
          All processing is local — your file does not leave your browser.
        </p>
        <button class="btn btn-primary" onClick={() => input.current?.click()}>
          Choose file
        </button>
        <input
          ref={input}
          type="file"
          accept=".fit,.FIT"
          hidden
          onChange={(e) => loadFirst((e.target as HTMLInputElement).files)}
        />
        {store.error.value && <div class="error">{store.error.value}</div>}
      </div>
    </div>
  )
}
